const BASE_URL = "https://www.squaremigration.com";

export function serviceSchemaScripts(opts: {
  path: string;
  name: string;
  description: string;
  serviceType: string;
}) {
  const url = `${BASE_URL}${opts.path}`;
  return [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: opts.name,
        serviceType: opts.serviceType,
        description: opts.description,
        url,
        areaServed: "US",
        provider: {
          "@type": "Organization",
          name: "Square Migration",
          url: BASE_URL,
        },
      }),
    },
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: BASE_URL },
          { "@type": "ListItem", position: 2, name: opts.name, item: url },
        ],
      }),
    },
  ];
}
